import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL

class StoreService {
  getAllStores() {
    return axios.get(API_URL + 'Shop')
  }
  getCurrentUserStores() {
    return axios.get(API_URL + '/store/current-user-stores')
  }
}

export default new StoreService()
